import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [FooterComponent],
    imports: [TranslateModule, CommonModule],
    exports: [FooterComponent],
})

export class FooterModule { }